import { render } from "./SaleDashboardView.vue?vue&type=template&id=241c6e73&scoped=true"
import script from "./SaleDashboardView.vue?vue&type=script&lang=js"
export * from "./SaleDashboardView.vue?vue&type=script&lang=js"

import "./SaleDashboardView.vue?vue&type=style&index=0&id=241c6e73&lang=scss&scoped=true"

import exportComponent from "/root/workspace/bjyx-h5_Pbc0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-241c6e73"]])

export default __exports__